import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfimationModalComponent } from './confimation-modal.component';

@Injectable()
export class ConfirmationModalService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    isPreviewExist?:boolean,
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    btnPreviewExist:string = 'Preview Report',
    dialogSize: 'sm' | 'lg' = "lg"): Promise<boolean> {
    const modalRef = this.modalService.open(ConfimationModalComponent);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.btnPreviewExist = btnPreviewExist;
    modalRef.componentInstance.isPreviewExist = isPreviewExist;


    return modalRef.result;
  }

}